import { render, staticRenderFns } from "./ioRecord.vue?vue&type=template&id=da5032e8&scoped=true"
import script from "./ioRecord.vue?vue&type=script&lang=js"
export * from "./ioRecord.vue?vue&type=script&lang=js"
import style0 from "./ioRecord.vue?vue&type=style&index=0&id=da5032e8&prod&scoped=true&lang=css"
import style1 from "./ioRecord.vue?vue&type=style&index=1&id=da5032e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5032e8",
  null
  
)

export default component.exports